import React, { useContext } from 'react';
// import { makeStyles } from '@material-ui/core/styles';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { headerData } from '../../data/headerData';
import { aboutData } from '../../data/aboutData'

function About() {

    const { theme, drawerOpen } = useContext(ThemeContext);
    
    // const useStyles = makeStyles((t) => ({
    //     serviceBtn: {
    //         backgroundColor: theme.primary,
    //         color: theme.secondary,
    //         textTransform: 'inherit',
    //         textDecoration: 'none',
    //         width: '150px',
    //         height: '50px',
    //         fontSize: '1rem',
    //         fontWeight: '500',
    //         fontFamily: 'var(--primaryFont)',
    //         border: `1px solid ${theme.secondary}`,
    //         transition: '250ms ease-in-out',
    //         '&:hover': {
    //             transform: 'scale(1.08)',
    //             backgroundColor: theme.secondary,
    //             color: theme.primary,
    //             border: `1px solid ${theme.secondary}`,
    //         },
    //     },
    // }));
    
    // const classes = useStyles();
    return (
        <div className='about' id='about'>
            <div className='about--container'>
                <div className='about--container-left'>
                    <div className='about--content' style={{ color: theme.secondary,textAlign:'left'}}>
                        <p style={{textAlign:'justify'}}>{aboutData.description1}</p>
                        <br></br>
                        <p style={{textAlign:'justify'}}>{aboutData.description2}</p>
                        <br></br>
                        <p style={{textAlign:'justify'}}>{aboutData.description3}</p>
                        <br></br>

                        <div className='about-buttonContainer'>
                            {/* <NavLink
                                to='/#contacts'
                                smooth={true}
                                spy='true'
                                duration={2000}
                        
                            > */}
                                {/* <Button className={classes.serviceBtn}>
                                    En savoir plus
                                </Button> */}
                            {/* </NavLink> */}
                        </div>
                    </div>
                </div>
                <img
                    src={headerData.image}
                    alt=''
                    className='about--img'
                    style={{
                        opacity: `${drawerOpen ? '0' : '1'}`
                    }}
                />
                <div
                    className='about--container-right'>
                </div>
            </div>
        </div>
    );
}

export default About
